export default __webpack_public_path__ + "static/media/cart-empty.a7b549d5.svg";